const $masthead = $('.masthead'),
    $stickyMasthead = $('.masthead__bottom'),
    $stickyMastheadMobile = $('.masthead__top'),
    classMastheadSticky = 'masthead__bottom--fixed',
    classMastheadStickyMobile = 'masthead__top--fixed';

function calculateStickyTreshold () {
    let stickyTreshold = $masthead.outerHeight() - $stickyMasthead.outerHeight();

    if (viewport().width < 1201) {
        stickyTreshold = 0;
    }

    if ($('.notification-bar').length > 0) {
        stickyTreshold = stickyTreshold + $('.notification-bar').outerHeight();
    }

    return stickyTreshold;
}

function setStickyMasthead () {
    let stickyTreshold = calculateStickyTreshold();

    $(window).on('resize', function () {
        // recalculate starting point on window resize
        stickyTreshold = calculateStickyTreshold();
    });

    $(window).on('scroll', function () {
        let scrolledDistance = $(document).scrollTop();

        if (scrolledDistance > stickyTreshold) {
            $masthead.css('height', $masthead.css('height'));

            $stickyMasthead.addClass(classMastheadSticky);

            if (viewport().width < 1201) {
                $stickyMastheadMobile.addClass(classMastheadStickyMobile);
            } else {
                $stickyMastheadMobile.removeClass(classMastheadStickyMobile);
            }
        } else {
            $stickyMasthead.removeClass(classMastheadSticky);

            if (viewport().width < 1201) {
                $stickyMastheadMobile.removeClass(classMastheadStickyMobile);
            }

            $masthead.css('height', 'auto');
        }
    });
}

setStickyMasthead();

$stickyMasthead.on('reset', function () {
    setStickyMasthead();
});